import Immutable from 'immutable';
import { ErrorList } from "../../../data/validation";
import { getFormItemLabel } from '../../../data/phrases';

export function validateAll(ctx, definition) {
	let errors = new ErrorList();
	definition.validateAll(ctx, errors);
	return errors;
};

function getDefinitionEntityName(definition, defaultValue) {
	let res = null;
	if (definition.getEntityName) {
		res = definition.getEntityName();
	}
	return res || defaultValue;
}

export function setLabels(def, entityName) {
	if (!def) {
		return def;
	}
//	console.log('def = ', def);
	if (def.setLabel && def.getName) {
		if (def.hasLabel && !def.hasLabel()) {
			def.setLabel(getFormItemLabel(def.getName(), entityName));
		}
	}
	if (def.getItems) {
		let itemEntityName = getDefinitionEntityName(def, entityName);
		def.getItems().forEach(item => {
			setLabels(item, itemEntityName);
		});
	}
	if (def.getContent) {
		let itemEntityName = getDefinitionEntityName(def, entityName);
		setLabels(def.getContent(), itemEntityName);
	}
	return def;
}

export function isDeleted(item) {
	return item.get('_deleted');
}

export function filterDeleted(list) {
	return (list || EMPTY_LIST).filter(item => !item.get('_deleted'));
}

